import LoginPage from "../components/LoginPage";
import Dashboard from "../components/Dashboard";
import EmployeeForm from "../components/EmployeeForm";
import EmployeeList from "../components/EmployeeList";
import ConfigPage from "../components/ConfigPage";
import CompanyManagement from "../components/CompanyManagement";
import ReportsPage from "../components/ReportsPage";
import UserManagement from "../components/UserManagement";
import ApiKeysPage from "../components/ApiKeysPage";
import ChartsReport from "../components/ChartsReport";
import PositionSalariesPage from "../components/PositionSalariesPage";
import SalaryUpgradePage from "../components/SalaryUpgradePage";
import HeadCountPage from "../components/HeadCountPage";
import ConsultasPage from "../components/ConsultasPage";
import DISCAssessmentPage from "../components/DISCAssessmentPage";
import PerformanceEvaluationPage from "../components/PerformanceEvaluationPage";
import PDIPage from "../components/PDIPage";
import NineBoxPage from "../components/NineBoxPage";
import LMSPage from "../components/LMSPage";
import TutorialPage from "../components/TutorialPage";
import DetailedEmployeeForm from "../components/DetailedEmployeeForm";
import VacationControlPage from "../components/VacationControlPage";
import SolicitarFeriasPage from "../components/SolicitarFeriasPage";
import DigitalSignaturePage from "../components/DigitalSignaturePage";
import WhatsAppIntegrationPage from "../components/WhatsAppIntegrationPage";
import EmailConfigPage from "../components/EmailConfigPage";
import SynklyWhatsAppPage from "../components/SynklyWhatsAppPage";
import UserProfilesPage from "../components/UserProfilesPage";
import SystemConfigPage from "../components/SystemConfigPage";
import DPFolhaConfigPage from "../components/DPFolhaConfigPage";
import EsocialPage from "../components/esocial/EsocialPage";
import ReinfPage from "../components/reinf/ReinfPage";
import FgtsPage from "../components/fgts/FgtsPage";
import DetPage from "../components/det/DetPage";
import DetArquivadasPage from "../components/det/DetArquivadasPage";
import EsocialDomesticoPage from "../components/esocial_domestico/EsocialDomesticoPage";
import DpDashboardPage from "../components/dp_dashboard/DpDashboardPage";
import AlertasPage from "../components/dp_dashboard/AlertasPage";
import GridRecruterIntegracaoPage from "../components/dp_dashboard/GridRecruterIntegracaoPage";
import EsocialCodigosPage from "../components/esocial/EsocialCodigosPage";
import ObrigacoesFiscaisPage from "../components/dp/ObrigacoesFiscaisPage";
import SSTAvancadoPage from "../components/dp/SSTAvancadoPage";
import GridMindPage from "../components/gridmind/GridMindPage";
import PortalGridMind from "../components/gridmind/PortalGridMind";
import MyProfilePage from "../components/MyProfilePage";
import FeedbackDashboard from "../components/feedback/FeedbackDashboard";
import Feedback360MainV2 from "../components/feedback/Feedback360MainV2";
import Dashboard360 from "../components/feedback/Dashboard360";
import SelecionarAvaliadores360 from "../components/feedback/SelecionarAvaliadores360";
import MinhasAvaliacoes360 from "../components/feedback/MinhasAvaliacoes360";
import Ciclo180Form from "../components/feedback/Ciclo180Form";
import Autoavaliacao180 from "../components/feedback/Autoavaliacao180";
import Resultado180 from "../components/feedback/Resultado180";
import Competencias180 from "../components/feedback/Competencias180";
import AvaliacaoGestor180 from "../components/feedback/AvaliacaoGestor180";
import Dashboard180 from "../components/feedback/Dashboard180";
import PDI180 from "../components/feedback/PDI180";
import PainelIA180 from "../components/feedback/PainelIA180";
import Relatorios180 from "../components/feedback/Relatorios180";
import Calibracao180 from "../components/feedback/Calibracao180";
import GerenciarFeedback180V2 from "../components/feedback/GerenciarFeedback180V2";
import MinhasAvaliacoes180 from "../components/feedback/MinhasAvaliacoes180";
import QuickFeedback from "../components/feedback/QuickFeedback90";
import OneOnOne90 from "../components/feedback/OneOnOne90";
import FrequencyDashboard90 from "../components/feedback/FrequencyDashboard90";
import FeedbackCultural from "../components/feedback/FeedbackCultural";
import FeedbackRelatorios from "../components/feedback/FeedbackRelatorios";
import DCFDashboard from "../components/dcf/DCFDashboard";
import GerenciarCargos from "../components/dcf/GerenciarCargos";
import Competencias from "../components/dcf/Competencias";
import Templates from "../components/dcf/Templates";
import Vinculacoes from "../components/dcf/Vinculacoes";
import ProfileDashboard from "../components/profile/ProfileDashboard";
import IdentidadeOrganizacional from "../components/profile/fit-cultural/IdentidadeOrganizacional";
import ConfiguracaoAvaliacao from "../components/profile/fit-cultural/ConfiguracaoAvaliacao";
import GerenciarFitCultural from "../components/profile/fit-cultural/GerenciarFitCultural";
import MinhasAvaliacoesFitCultural from "../components/profile/fit-cultural/MinhasAvaliacoesFitCultural";
import AvaliacaoDesempenhoAvancada from "../components/AvaliacaoDesempenhoAvancada";
import AvaliacaoDesempenhoWizard from "../components/AvaliacaoDesempenhoWizard";
import PDICompletoMain from "../components/pdi/PDICompletoMain";
import NineBoxInteligente from "../components/NineBoxInteligente";
import MinhaAutoavaliacao from "../components/MinhaAutoavaliacao";
import ComparacaoBifocal from "../components/ComparacaoBifocal";
import ResultadosIndividuais from "../components/profile/fit-cultural/ResultadosIndividuais";
import FitCulturalDashboard from "../components/profile/fit-cultural/FitCulturalDashboard";
import DashboardAnalytics from "../components/profile/fit-cultural/DashboardAnalytics";
import ComparacaoCandidatos from "../components/profile/fit-cultural/ComparacaoCandidatos";
import ValidacaoCientifica from "../components/profile/fit-cultural/ValidacaoCientifica";
import GridProfileInventory from "../components/GridProfileInventory";
import CognitiveAssessmentPage from "../components/CognitiveAssessmentPage";
import EnglishAssessmentPage from "../components/EnglishAssessmentPage";
import ExcelAssessmentPage from "../components/ExcelAssessmentPage";
import PortugueseAssessmentPage from "../components/PortugueseAssessmentPage";
import SurveyPage from "../components/SurveyPage";
import GerenciarMatrizes9Box from "../components/ninebox/GerenciarMatrizes9BoxV2";
import EstrategiasAutomaticas9Box from "../components/ninebox/EstrategiasAutomaticas9Box";
import PDIMultiFonte from "../components/place-synx/PDIMultiFonte";
import NineBoxPotencialEnriquecido from "../components/place-synx/NineBoxPotencialEnriquecido";
import DashboardPlaceSynx from "../components/place-synx/DashboardPlaceSynx";
import TimeTrackingPage from "../components/TimeTrackingPage";
import TimeTrackingAdminPage from "../components/TimeTrackingAdminPage";
import ContractManagementPage from "../components/ContractManagementPage";
import ContractIntelligencePage from "../components/ContractIntelligencePage";
import GestaoProcessosPage from "../components/juridico/GestaoProcessosPage";
import GestaoProcessoDetailPage from "../components/juridico/GestaoProcessoDetailPage";
import ContractTypesPage from "../components/ContractTypesPage";
import TiposDocumentosPage from "../components/TiposDocumentosPage";
import DocumentosRHPage from "../components/DocumentosRHPage";
import DocumentosFuncionarioPage from "../components/DocumentosFuncionarioPage";
import GerenciarSolicitacoesPage from "../components/GerenciarSolicitacoesPage";
import RHProcessListPage from "../components/rh/RHProcessListPage";
import RHProcessFormPage from "../components/rh/RHProcessFormPage";
import RHProcessDetailPage from "../components/rh/RHProcessDetailPage";
import RHAdmissaoExamePage from "../components/rh/RHAdmissaoExamePage";
import RHConfigProcessesPage from "../components/rh/RHConfigProcessesPage";
import TiposDemissaoPage from "../components/TiposDemissaoPage";
import EtniasPage from "../components/EtniasPage";
import GrausHierarquiaPage from "../components/GrausHierarquiaPage";
import MetricasPage from "../components/MetricasPage";
import PontoPWAPage from "../components/PontoPWAPage";
import FolhaPontoPWA from "../components/FolhaPontoPWA";
import DocumentosPWA from "../components/DocumentosPWA";
import RegistroViagemPWA from "../components/RegistroViagemPWA";
import AdminViagemPage from "../components/AdminViagemPage";
import RegistroViagemPage from "../components/RegistroViagemPage";
import DetalhesViagemPage from "../components/DetalhesViagemPage";
import BancoHorasPage from "../components/BancoHorasPage";
import FeriadosPage from "../components/FeriadosPage";
import HoleritesPage from "../components/HoleritesPage";
import JustificativasFaltaPage from "../components/JustificativasFaltaPage";
import Escolaridade from "../components/cadastros/Escolaridade";
import MinhasAvaliacoes from "../components/MinhasAvaliacoes";
import PreencherAvaliacao from "../components/PreencherAvaliacao";
import DashboardAvaliacoes from "../components/DashboardAvaliacoes";
import CadastrosPage from "../components/CadastrosPage";
import WhatsAppChatbotPage from "../components/WhatsAppChatbotPage";
import PinManagerPage from "../components/PinManagerPage";
import EspelhoPontoPage from "../components/EspelhoPontoPage";
import PontoDevicesPage from "../components/rh/PontoDevicesPage";
import EstagiarioListPage from "../components/estagiario/EstagiarioListPage";
import EstagiarioDetailPage from "../components/estagiario/EstagiarioDetailPage";
import BirthdaysPage from "../components/BirthdaysPage";
import SystemPrivacyPoliciesPage from "../components/SystemPrivacyPoliciesPage";

export const componentMap = {
  LoginPage,
  Dashboard,
  EmployeeForm,
  EmployeeList,
  ConfigPage,
  CompanyManagement,
  ReportsPage,
  UserManagement,
  ChartsReport,
  PositionSalariesPage,
  SalaryUpgradePage,
  HeadCountPage,
  ConsultasPage,
  DISCAssessmentPage,
  PerformanceEvaluationPage,
  PDIPage,
  NineBoxPage,
  LMSPage,
  TutorialPage,
  DetailedEmployeeForm,
  VacationControlPage,
  SolicitarFeriasPage,
  DigitalSignaturePage,
  WhatsAppIntegrationPage,
  EmailConfigPage,
  SynklyWhatsAppPage,
  UserProfilesPage,
  ApiKeysPage,
  SystemConfigPage,
  DPFolhaConfigPage,
  EsocialPage,
  ReinfPage,
  FgtsPage,
  DetPage,
  DetArquivadasPage,
  EsocialDomesticoPage,
  DpDashboardPage,
  AlertasPage,
  GridRecruterIntegracaoPage,
  EsocialCodigosPage,
  ObrigacoesFiscaisPage,
  SSTAvancadoPage,
  GridMindPage,
  PortalGridMind,
  MyProfilePage,
  FeedbackDashboard,
  Feedback360MainV2,
  Dashboard360,
  SelecionarAvaliadores360,
  MinhasAvaliacoes360,
  Ciclo180Form,
  Autoavaliacao180,
  Resultado180,
  Competencias180,
  AvaliacaoGestor180,
  Dashboard180,
  PDI180,
  PainelIA180,
  Relatorios180,
  Calibracao180,
  GerenciarFeedback180V2,
  MinhasAvaliacoes180,
  QuickFeedback,
  OneOnOne90,
  FrequencyDashboard90,
  FeedbackCultural,
  FeedbackRelatorios,
  DCFDashboard,
  GerenciarCargos,
  Competencias,
  Templates,
  Vinculacoes,
  ProfileDashboard,
  IdentidadeOrganizacional,
  ConfiguracaoAvaliacao,
  GerenciarFitCultural,
  MinhasAvaliacoesFitCultural,
  AvaliacaoDesempenhoAvancada,
  AvaliacaoDesempenhoWizard,
  PDICompletoMain,
  NineBoxInteligente,
  MinhaAutoavaliacao,
  ComparacaoBifocal,
  ResultadosIndividuais,
  FitCulturalDashboard,
  DashboardAnalytics,
  ComparacaoCandidatos,
  ValidacaoCientifica,
  GridProfileInventory,
  CognitiveAssessmentPage,
  EnglishAssessmentPage,
  ExcelAssessmentPage,
  PortugueseAssessmentPage,
  SurveyPage,
  GerenciarMatrizes9Box,
  EstrategiasAutomaticas9Box,
  PDIMultiFonte,
  NineBoxPotencialEnriquecido,
  DashboardPlaceSynx,
  TimeTrackingPage,
  TimeTrackingAdminPage,
  ContractManagementPage,
  ContractIntelligencePage,
  GestaoProcessosPage,
  GestaoProcessoDetailPage,
  ContractTypesPage,
  TiposDocumentosPage,
  DocumentosRHPage,
  DocumentosFuncionarioPage,
  GerenciarSolicitacoesPage,
  RHProcessListPage,
  RHProcessFormPage,
  RHProcessDetailPage,
  RHAdmissaoExamePage,
  RHConfigProcessesPage,
  TiposDemissaoPage,
  EtniasPage,
  GrausHierarquiaPage,
  MetricasPage,
  PontoPWAPage,
  FolhaPontoPWA,
  DocumentosPWA,
  RegistroViagemPWA,
  AdminViagemPage,
  RegistroViagemPage,
  DetalhesViagemPage,
  BancoHorasPage,
  FeriadosPage,
  HoleritesPage,
  JustificativasFaltaPage,
  Escolaridade,
  MinhasAvaliacoes,
  PreencherAvaliacao,
  DashboardAvaliacoes,
  CadastrosPage,
  WhatsAppChatbotPage,
  PinManagerPage,
  EspelhoPontoPage,
  PontoDevicesPage,
  EstagiarioListPage,
  EstagiarioDetailPage,
  BirthdaysPage,
  SystemPrivacyPoliciesPage,
};
